export const typePolicies = {
  Home: { merge: true },
  Battery: { merge: true },
  Bms: { merge: true },
  Company: { merge: true },
  Ecus: { merge: true },
  Powertrain: { merge: true },
  Software: { merge: true },
};
